import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetAllGroupsUserResponse } from 'domain/models';

interface IGroupsState {
  groupsUser: GetAllGroupsUserResponse[];
  loadingGroupsUser: boolean;
}

interface IPayloadGroupsUser
  extends PayloadAction<GetAllGroupsUserResponse[]> {}

const initialState: IGroupsState = {
  groupsUser: [],
  loadingGroupsUser: false,
};

export const GroupsSlice = createSlice({
  name: 'groups',
  initialState,
  reducers: {
    loadGroupsUser: (state, action: IPayloadGroupsUser) => {
      state.groupsUser = action.payload;
    },
    setLoadingGroupsUser: (state, action: PayloadAction<boolean>) => {
      state.loadingGroupsUser = action.payload;
    },
  },
});

export const { loadGroupsUser, setLoadingGroupsUser } = GroupsSlice.actions;

export default GroupsSlice.reducer;
